import styled from "styled-components";

export const HrReset = styled.hr`
  background-color: transparent;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  margin: 0;
  outline: none;
`;



// WEBPACK FOOTER //
// ./src/components/hr-reset/hr-reset.component.js